import { Select } from '@common/forms'
import { useAppDispatch, useAppSelector } from '@common/hooks'
import { fetchAppVersion } from '@redux/slices/appVersions'
import type { IVersion } from '@redux/slices/appVersions/appVersions.types'
import { useEffect } from 'react'

import styles from './styles.module.scss'


const getVersionsOptions = (versions?: IVersion[] | null): IOption[] => {
  if(!versions || !versions.length) { return [] }
  return versions.map(version => ({
    label: version.version,
    value: version.id,
  }))
}

interface IProps {
  value: string | undefined,
  onChange: (version: string) => void,
}

export default function VersionSelector({
  value,
  onChange,
}: IProps): JSX.Element {
  const dispatch = useAppDispatch()
  const application = useAppSelector(store => store.application?.data) as IApplication
  const versions = useAppSelector(store => store.appVersions?.data)

  useEffect(() => {
    void dispatch(fetchAppVersion(application.id))
  }, [])


  useEffect(() => {
    if(versions && value === undefined) {
      const installedVersion = application?.installed?.id
      const activeVersion = versions.find(version => version.id === installedVersion)?.id || versions[0].id
      onChange(activeVersion)
    }
  }, [versions, value])

  const handleVersionChange = (version: unknown) => {
    onChange(version as string)
  }

  return (
    <Select
      onChange={handleVersionChange}
      options={getVersionsOptions(versions)}
      value={value}
      name="version"
      error={false}
      className={styles.select}
      classNameControl={styles.control}
      classNameIndicator={styles.indicator}
      classNameSingleValue={styles.singleValue}
      classNameOption={styles.option}
    />
  )
}
